const terms = new Map<string, SocketTerminal>();

export function getCurrentTerminals() {
  return [...terms.values()];
}
export class SocketTerminal {
  private history: any[] = [];

  private sockets = new Set<any>();

  onData: ((data: any) => void) | null = null;

  constructor(readonly name: string, readonly tags: string[] = [], io: SocketIO.Server) {
    io.of("/" + name).on("connection", socket => {
      socket.emit("clear");

      let joined = "";
      for (const el of this.history) {
        joined += el;
        if (joined.length > 20000) {
          socket.emit("data", joined);
          joined = "";
        }
      }
      if (joined.length > 0) {
        socket.emit("data", joined);
      }

      this.sockets.add(socket);
      socket.on("input", data => {
        if (this.onData != null) {
          this.onData(data);
        }
      });
    });
    io.of("/" + name).on("disconnect", socket => {
      this.sockets.delete(socket);
    });
  }

  private currentFlushTimeout: NodeJS.Timer | null = null;
  private currentFlushMessages: string = "";

  write(data: any) {
    if (this.currentFlushTimeout == null) {
      this.currentFlushTimeout = setTimeout(() => {
        for (const socket of this.sockets) {
          socket.emit("data", this.currentFlushMessages);
        }
        this.currentFlushMessages = "";
        this.currentFlushTimeout = null;
      }, 50);
    }
    this.history.push(data);
    this.currentFlushMessages += data;
  }

  static getTerminal(name: string) {
    return terms.get(name);
  }

  static getOrCreateTerminal(name: string, tags: string[], io: SocketIO.Server) {
    if (!terms.has(name)) {
      terms.set(name, new SocketTerminal(name, tags, io));
      io.emit("terms", [...terms.values()].map(el => ({ name: el.name, tags: el.tags })));
    }
    return SocketTerminal.getTerminal(name);
  }
}
